"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var FreeShippingThresholdText_1 = require("./FreeShippingThresholdText");
var FreeShippingThresholdProgressBar_1 = require("./FreeShippingThresholdProgressBar");
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("./CartContext");
var FreeShippingThreshold = function () {
    var _a = (0, hooks_1.useContext)(CartContext_1.default), cart = _a.cart, hasSubscription = _a.hasSubscription;
    var cartTotal = cart.items_subtotal_price;
    var FREE_SHIPPING_THRESHOLD = 7000;
    // display free shipping bar only if no sub items
    return ((0, preact_1.h)("div", { class: "cart-section__review-threshold" }, !hasSubscription && ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)(FreeShippingThresholdText_1.default, { cartTotal: cartTotal, threshold: FREE_SHIPPING_THRESHOLD }),
        (0, preact_1.h)(FreeShippingThresholdProgressBar_1.default, { cartTotal: cartTotal, threshold: FREE_SHIPPING_THRESHOLD })))));
};
exports.default = FreeShippingThreshold;
